/**
 * Session-scoped dismissal store for the inline upgrade nudges.
 *
 * Keyed by a "moment id" (e.g. 'memo-footer', 'session-precompile').
 * Dismissals live in sessionStorage, NOT localStorage, on purpose: the
 * roadmap calls for a nudge to fire "exactly once per moment — dismiss
 * it and it does not appear again in the same session." sessionStorage
 * clears when the browser session (tab) ends, so a dismissed nudge
 * stays gone for the rest of the visit but returns on a fresh session.
 * localStorage would suppress it forever, which is the wrong contract.
 */

const key = (id: string) => `edash.nudge.${id}.dismissed`;

export function isNudgeDismissed(id: string): boolean {
  try {
    return sessionStorage.getItem(key(id)) === '1';
  } catch {
    // sessionStorage can be unavailable (incognito, quota). Treat as
    // "not dismissed" so the nudge still shows — failing open is the
    // right call for a purely promotional surface.
    return false;
  }
}

export function dismissNudge(id: string): void {
  try {
    sessionStorage.setItem(key(id), '1');
  } catch {
    // No-op when sessionStorage is unavailable; the nudge simply won't
    // remember its dismissal, which is harmless.
  }
}
